import { z } from 'zod';
import { defineEndpoint } from '../contract.ts';
import { PageQuery, paginated } from '../pagination.ts';
import { timestamp } from '../schemas.ts';

// The audit trail's API (design §6.8). The viewer page comes in milestone 1C.

export const AuditEntry = z.object({
  id: z.string(),
  /** `request`: written by core for every change request. `domain`: written by a service, with before and after. */
  kind: z.enum(['request', 'domain']),
  /** `POST /bank/entries/:id` for requests, `bank.entry.approved` for domain entries. */
  action: z.string(),
  module: z.string(),
  /** `user:<id>`, `discord:<discord id>`, `service:<module>`, `system` or `anonymous`. */
  actor: z.string(),
  actorUser: z.string().nullable(),
  targetType: z.string(),
  targetId: z.string(),
  /** The HTTP status for requests, `ok` for domain entries. */
  outcome: z.string(),
  before: z.unknown(),
  after: z.unknown(),
  requestId: z.string(),
  created: timestamp,
});
export type AuditEntry = z.infer<typeof AuditEntry>;

export const AuditQuery = PageQuery.extend({
  module: z.string().max(64).optional(),
  /** An exact actor reference, such as `user:abc123def456ghi`. */
  actor: z.string().max(128).optional(),
  targetType: z.string().max(128).optional(),
  targetId: z.string().max(256).optional(),
  /** Matches actions starting with this. */
  action: z.string().min(1).max(256).optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
});

export const listAudit = defineEndpoint({
  method: 'GET',
  path: '/admin/audit',
  permission: 'core.audit.view',
  query: AuditQuery,
  response: paginated(AuditEntry),
});
